<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj" :style="{ background: navbarColorLocal }"
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >
        <!-- Left: Logo + Title -->
        <div class="flex items-center">
          <img
            src="/logo.png"
            alt="POK"
            style="
              width: 36px;
              height: 36px;
              border-radius: 50%;
              object-fit: cover;
            "
            class="mr-3 cursor-pointer"
            @click="goHome"
          />
          <div class="hidden sm:block">
            <p
              style="
                color: var(--pok-text);
                font-size: 14px;
                font-weight: 800;
                letter-spacing: 1px;
                line-height: 1.2;
              "
            >
              PALACE OF KEBAP
            </p>
            <p style="color: #999; font-size: 11px">Düsseldorf</p>
          </div>
        </div>

        <vs-spacer />

        <!-- Right: Cart + Profile -->
        <div class="flex items-center">
          <div class="nav-cart-btn mr-3" @click="openCart">
            <feather-icon
              icon="ShoppingBagIcon"
              svgClasses="w-5 h-5"
              style="color: var(--pok-text)"
            />
            <span v-if="cartLength > 0" class="nav-cart-badge">{{
              cartLength
            }}</span>
          </div>
          <profile-drop-down />
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import ProfileDropDown from "./components/ProfileDropDown.vue";

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    ProfileDropDown,
  },
  computed: {
    cartLength() {
      return this.$store.getters["shop/getCartLength"] || 0;
    },
    navbarColorLocal() {
      return this.$store.state.theme === "dark" ? "#121212" : "#FAF6F1";
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        "text-white":
          (this.navbarColor != "#121212" &&
            this.$store.state.theme === "dark") ||
          (this.navbarColor != "#fff" && this.$store.state.theme !== "dark"),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    classObj() {
      if (this.verticalNavMenuWidth === "default") return "navbar-default";
      else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
      return "navbar-default";
    },
  },
  methods: {
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    goHome() {
      window.location.href = "/";
    },
    openCart() {
      if (this.cartLength > 0) {
        this.$root.$emit("openMobileCart");
      }
    },
  },
};
</script>

<style scoped>
.nav-cart-btn {
  position: relative;
  padding: 8px;
  background: var(--pok-card);
  border-radius: 12px;
  border: 1px solid var(--pok-border);
  cursor: pointer;
  transition: border-color 0.2s;
}
.nav-cart-btn:hover {
  border-color: #666;
}
.nav-cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  background: #c41e2a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
